<template>
    <div class="col-12">
        <div class="search-padd">
            
                <div class="col-xs-12 override-padding">
                    <div class="crm_admin_heading menu_heading_1"></div>
                </div>
                <div style="clear: both;"></div>
                <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                <b-alert
                  :show="dismissAuthCountDown"
                  dismissible
                  variant="success"
                  @dismissed="dismissAuthCountDown=0"
                  @dismiss-count-down="countDownAuthChanged"
                  >
                  {{ success_auth_message }}
                </b-alert>
                <div class="admin_details">
                    <div class="crm_admin_field_lists menu_btn_1">
                        <div class="search-padd">
                            <button v-if="isInActive"
                                type="button"
                                id="account_status"
                                class="btn btn-sm ma-blue-btn"
                                name="account_status"
                                v-on:click="updateAccountStatus('Active');">
                                Activate Enterprise
                            </button>
                            <button v-if="isActive"
                                type="button"
                                id="account_status"
                                class="btn btn-sm ma-gray-btn"
                                name="account_status"
                                v-on:click="updateAccountStatus('Inactive');">
                                Inactivate Enterprise
                            </button>
                        </div>
                    </div>
                    <div class="crm_admin_field_lists menu_btn_2">
                        <div class="search-padd">
                            <button v-if="isInActive"
                                type="button"
                                id="account_status"
                                class="btn btn-sm ma-gray-btn"
                                name="account_status"
                                v-on:click="updateAccountStatus('Delete');">
                                Delete Enterprise
                            </button>
                        </div>
                    </div>
                    <div v-if="accountStatus == 'Delete'" class="alert alert-danger">Enterprise is deleted</div>
                    <div v-if="accountStatus == 'Prospect'" class="alert alert-danger">Enterprise is Prospect</div>
                </div>
                <div style="clear: both;"></div>



          <div class="form-group pt-4">
            <div class="row">
              <div class="col-3">
              <input
                type="checkbox"
                v-bind:id="submit_addtransfer"
                v-bind:name="submit_addtransfer"
                ref="submit_addtransfer"
                v-model="submit_addtransfer_selected"
                :checked="submit_addtransfer_checked"
                :value="1" style="margin-top: 4px;">
              <label class="" for="submit_addtransfer_1">Enable Add/Transfer Feature</label>
              </div>
              <div class="col-6" style="margin-top: 0px;">
                  <button @click="onSubmit" type="submit" class="btn btn-sm ma-blue-btn">Save</button>
              </div>

            </div>
          </div>






          <div style="clear: both;"></div>
          <div class="col-12 mt-3 mb-5 p-0">
          <div class="shadow p-3 information_box" style="background-color: #FFF;">

          <div class="bold mb-3 pb-1" style="margin-top: 2px; border-bottom: 1px solid #00ACEE;">
              Branding:
          </div>
          <div class="row">
          <div class="col-5">
            <div class=" row">
                <div class="col-12">
                <input
                  type="checkbox"
                  v-bind:id="submit_branding"
                  v-bind:name="submit_branding"
                  ref="submit_branding"
                  v-model="submit_branding_selected"
                  :checked="submit_branding_checked"
                  :value="1" style="margin-top: 4px;">
                <label class="" for="submit_branding_1">Enable Branding</label>
                </div>
            </div>
            <div class=" row">
                <div class="col-12">
                <input
                  type="checkbox"
                  v-bind:id="submit_white_text"
                  v-bind:name="submit_white_text"
                  ref="submit_white_text"
                  v-model="submit_white_text"
                  :checked="submit_white_text_checked"
                  :value="1" style="margin-top: 4px;">
                <label class="" for="submit_white_text_1">Enable White Text/Icon for Navigation color</label>
                </div>
            </div>
            <div class=" row">
                <div class="col-12">
                <input
                  type="checkbox"
                  v-bind:id="submit_custom_link"
                  v-bind:name="submit_custom_link"
                  ref="submit_custom_link"
                  v-model="submit_custom_link"
                  :checked="submit_custom_link_checked"
                  :value="1" style="margin-top: 4px;">
                <label class="" for="submit_custom_link_1">Enable Custom Link</label>
                </div>
            </div>

            <div class="row pb-3" v-if="this.submit_custom_link == true">
            <div class="col-12 bold text-left pt-1">
              Custom Link: 
            </div>
            <div class="col-12 datepicker-custom  pl-4">
              {{ protocol }}
              <input v-model="sub_domain"
                name="sub_domain"
                placeholder="Custom Link"
                class="col-2 padding-lr-5 input-class input-height-25 text-left" style="border-radius: 10px;" v-validate="{ rules: { required: true, regex: nameRegex() } }"
                maxlength="150" />
              {{ host }}
            </div>
            <div v-if="verrors.firstByRule('sub_domain', 'required')"  class="col-12 validate-warning-msg">Custom link is required</div>
            <div v-if="verrors.firstByRule('sub_domain', 'regex')"  class="col-12 validate-warning-msg">Custom link is invalid only small characters allowed.</div>
            <div v-if="verrors.firstByRule('sub_domain', 'exists')"  class="col-12 validate-warning-msg">Custom link is already exists.</div>
            </div>


            <div class="col-12 p-0 pl-5" style="margin-top: 0px;">
                <button @click="onBrandingSubmit" type="submit" class="btn btn-sm ma-blue-btn">Save</button>
            </div>


          </div>

          <div class="col-7">
            <div class="row">
              <div class="col-5 p-0">
                <div class="bold cursor-pointer" style="color: #00ACEE; " v-if="flag == 1" @click="openSettingsModal()">
                    View Branding Settings
                </div>
              </div>
              <div class="col-7 p-0">
                <div class="bold mb-3" style="margin-top: 0px;" v-if="status != ''">
                    <button v-if="status == 'Approved'" class="btn btn-red btn-md input-height-15 text-center" style="border-radius: 10px; background-color: #28a745 !important; color: #FFF;"><i class="fa fa-check-circle" aria-hidden="true"></i> Approved</button>
                    <button v-if="status == 'Denied'" class="btn btn-red btn-md input-height-15 text-center" style="border-radius: 10px; background-color: #dc3545 !important; color: #FFF;"><i class="fa fa-times-circle" aria-hidden="true"></i> Denied</button>
                    <button v-if="status == 'Pending'" class="btn btn-red btn-md input-height-15 text-center" style="border-radius: 10px; background-color: #ffc107 !important; color: #FFF;"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Waiting for approval</button>
                </div>
              </div>

            </div>

          </div>
          </div>

          <BrandingSettingsModal 
            :isModalVisible="isBrandingSettingModalVisible" 
            :accountId="accountId"
            @close="closeSettingModal"
            ref="branding_settings">
          </BrandingSettingsModal>

          </div>
          </div>
            
        </div>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import { store } from '../../store/store';
Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});
import BrandingSettingsModal from './enterprise_lookup_branding_setting_display.vue';

export default {
      props: ['accountId', 'accountStatus'],
      data() {
        return {
          loading: true,
          statusText: '',
          submit_addtransfer_selected: false,
          submit_addtransfer_checked: 0,
          index: '',
          success_auth_message: '',
          dismissAuthCountDown: 0,
          isBrandingSettingModalVisible: false,
          flag: 0,
          status: '',
          success_auth_message: '',
          dismissAuthCountDown: 0,
          fullDomain: '',
          sub_domain: '',
          host: '',
          protocol: '',
          submit_branding_selected: false,
          submit_branding_checked: 0,
          submit_custom_link: false,
          submit_custom_link_checked: 0,
          submit_white_text: false,
          submit_white_text_checked: 0,
        }
      },
      computed: {
        isActive() {
          if (this.accountStatus == 'Active') {
            return true;
          }
        },
        isInActive() {
          if (this.accountStatus == 'Inactive') {
            return true;
          }
        }
      },
      components: {
        BrandingSettingsModal
      },
      methods: {

        nameRegex: function() {
          return /^[a-z']*$/;
        },
        openSettingsModal: function() {
          this.isBrandingSettingModalVisible = true;
          this.$refs.branding_settings.getBrandingDetail();
        },
        closeSettingModal() {
          this.isBrandingSettingModalVisible = false;
          this.getBrandingDetail();      
        },
        getBrandingDetail() {        
          axios('/get-account-settings/' + this.accountId ,
          {
              method: 'GET',
          },
          )
          .then((resp)=> {
            this.submit_branding_selected = resp.data.isBranding;
            this.submit_custom_link = resp.data.isCustomLink;
            this.submit_white_text = resp.data.isWhiteText;
            this.sub_domain = resp.data.subdomain;

          })
          .catch(() => {
          });
          axios('/desktop/get-account-color-code-logo/' + this.accountId,
          {
            method: 'GET',
          })
          .then(resp => {
              if(resp.data.flag == 1) {
                this.flag = 1;
              }
              this.status = resp.data.status;
          })
          .catch(() => {
          });

        },

        onBrandingSubmit() {
          this.$validator.validateAll().then((result) => {
          if(!result) {
            return;
          }
          
          if(this.accountId > 0) {
            this.fullDomain = this.protocol + this.sub_domain + this.host;
            if(this.submit_custom_link == false) {
              this.fullDomain = '';
              this.sub_domain = '';
            }
            axios('/update-account-settings/' + this.accountId ,
            {
                method: 'POST',
                data: {
                "submit_branding": this.submit_branding_selected,
                "submit_custom_link": this.submit_custom_link,
                "submit_white_text": this.submit_white_text,
                "sub_domain": this.fullDomain,
                }
            },
            )
            .then(()=> {
                this.success_auth_message = 'Account branding settings updated successfully.';
                this.dismissAuthCountDown = 5;
                this.getBrandingDetail();
            })
            .catch(error => {
              const fieldErrors =  [{}];
              var errMsgObj = JSON.parse(error.response.data.message);
              console.log(errMsgObj);
              Object.keys(errMsgObj).map(key => {
              console.log(errMsgObj[key]);
              var newFieldErr = {field:key, msg:errMsgObj[key], rule: 'exists'};
              fieldErrors.push(newFieldErr);
              });
              console.log(fieldErrors);
              this.$validator.errors.add(fieldErrors);

            });

          }
          })
          .catch(() => {

          });
        },

        countDownAuthChanged(dismissAuthCountDown) {
          this.dismissAuthCountDown = dismissAuthCountDown;
        },

        onSubmit() {
          
          if(this.accountId > 0) {
            axios('/update-account-addtransfer-settings/' + this.accountId ,
            {
                method: 'POST',
                data: {
                "submit_addtransfer": this.submit_addtransfer_selected,
                }
            },
            )
            .then(()=> {
                this.success_auth_message = 'Account add/transfer settings updated successfully.';
                this.dismissAuthCountDown = 5;
            })
            .catch(() => {
            });

          }
        },

        updateAccountStatus(statusName) {
            this.loading = true;
            axios("/enterprise_status_update", {
                method: 'POST',
                data: {
                    account_id: this.accountId,
                    status: statusName,
                }
            })
            .then(response => {
              this.loading = false;
              var flashMsg = '';
              if (statusName == 'Inactive') {
                flashMsg = 'Enterprise is Inactivated';
              }
              if (statusName == 'Delete') {
                flashMsg = 'Enterprise is Deleted';
              }
              this.flash({ message: flashMsg, variant: 'success' });
              this.$router.push(this.$router.currentRoute.fullPath)
              this.$router.go();
            })
            .catch(error => {
            });
        }  
      },
      created: function () {
        this.account_type = this.$parent.org_type;
        if(process.env.NODE_ENV == 'production') {
          this.host = "." + process.env.SUBDOMAIN_HOST;
        }
        else {
          this.host = "-" + process.env.SUBDOMAIN_HOST;
        }
        this.protocol = window.location.protocol + "//";
        this.loading = false;
        this.getBrandingDetail();

        axios('/get-account-addtransfer-settings/' + this.accountId ,
        {
            method: 'GET',
        },
        )
        .then((resp)=> {
          this.submit_addtransfer_selected = resp.data.isCanAddTransfer;
          this.submit_addtransfer_checked = resp.data.isCanAddTransfer;

        })
        .catch(() => {
        });

      },
    }
</script>
<style scoped>
.menu_heading_1 { width: 100%; }
.menu_btn_1 { width: 35%; }
.menu_btn_2 { width: 65%; }
.ma-gray-btn, .ma-gray-btn:active .ma-gray-btn:hover, .ma-gray-btn:focus {
    color: #FFF !important;
    border: 1px solid #bcb8b8 !important;
    background: #bcb8b8 !important;
    padding: 5px; 
    font-weight: 900;
    width: 200px;
}
.ma-blue-btn, .ma-blue-btn:hover, .ma-blue-btn:focus {
  color: #FFF !important; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  border-radius: 0 !important;
  width: 120px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/enterprise_lookup_menu_tab.vue